import { Component } from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {Container} from 'react-bootstrap';
import PageTitle from '../../../../common/page-title';
import NavigationLinksList from './navigationlinks-list';
import ArrowButton from '../../../../common/button-arrow';
import {getNavigationLinks} from '../../../../../actions/navigationlinks';

class ListNavigationLinks extends Component {
  componentDidMount() {
    this.props.dispatch(getNavigationLinks());
  }

  render() {
    return (
      <Container fluid className="navigationlinks">
        <PageTitle>
          Navigation Links
        </PageTitle>
        <Link to="/admin/navigation/links/new">
          <ArrowButton
            arrow={false}
            className="add-navigation-link"
            permissions={{
              action: 'add',
              subjectClass: 'NavigationLink'
            }}
            submit={false}
          >
            Add link
          </ArrowButton>
        </Link>

        <NavigationLinksList
          fetched={this.props.fetched}
          fetching={this.props.fetching}
          navigationLinks={this.props.navigationLinks}
        />
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  navigationLinks: state.navigationLinks.navigationLinks,
  fetched: state.navigationLinks.fetched,
  fetching: state.navigationLinks.fetching,
});

export default connect(mapStateToProps)(ListNavigationLinks);
